import EventBus from '../EventBus'

export default {
    methods: {
        snackbar: function (m) {
            EventBus.$emit("OpenSnackBar", {
                m: m
            })
        },
        snackbarWarn: function (m) {
            EventBus.$emit("OpenSnackBar", {
                m: m,
                warning : true
            })
        },
        snackbarError: function (m) {
            EventBus.$emit("OpenSnackBar", {
                m: m,
                error : true
            })
        },
        snackbarSuccess: function (m) {
            EventBus.$emit("OpenSnackBar", {
                m: m,
                success : true
            })
        },
        snackbarAuto: function (apiResponse) {
            if (apiResponse == undefined) return;
            if (apiResponse.ok) {
                if (apiResponse.message) {
                    this.snackbarSuccess(apiResponse.message)
                }
            } else if (apiResponse.error) {
                this.snackbarError(apiResponse.error)
            }
        }
    }
}